import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const OperatorConnectVoicePoliciesField = ({
    value,
    onChange,
    options,
    darkMode,
    error,
    showError,
    disableStackHeight,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const multiValue = (value || []).map((v) => v?.id ?? v);
    const handleSelectChange = (selectedIds) => {
        const selectedItems = (selectedIds || [])
            .map((id) => (options || []).find((opt) => opt.id === id))
            .filter(Boolean);
        onChange(selectedItems);
    };
    return (
        <FormControl
            sx={{ margin: '0 0 24px 0 !important' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={
                    disableStackHeight
                        ? { width: '775px' }
                        : {
                              ...stackStyling(true),
                              height: 'auto',
                              minHeight: '75px',
                          }
                }>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height="100%">
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Voice Policies{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select one or more voice policies for this service.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px" height="auto">
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <DropDown
                                name="voicePolicies"
                                data={options}
                                shownValue="name"
                                isMulti
                                multiValue={multiValue}
                                noPadding
                                placeholder="- Select Voice Policies -"
                                walkthroughId={
                                    walkthroughIds.serviceProfiles
                                        ?.ufVoicePoliciesSelect
                                }
                                darkMode={darkMode}
                                width="100%"
                                handleSelectChange={handleSelectChange}
                            />
                            {showError && (
                                <Text
                                    color="red.500"
                                    fontSize="xs"
                                    mt={1}
                                    textAlign="right">
                                    {error}
                                </Text>
                            )}
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select one or more voice policies for this service."
                        ariaLabel="operator-connect-voice-policies-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OperatorConnectVoicePoliciesField;
